export enum EnumStopAction {
  Active= 1,
  Stopped,
  Cancel
}

export namespace EnumStopAction {
  export function values() {
    return Object.keys(EnumStopAction).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
